import type { Project } from '@pn/core/domain/project';
import type { User } from '@pn/core/domain/user';
import type { WorkspaceItem } from '@pn/core/domain/workspace';
import { isNil } from 'lodash-es';

const GLOBAL_ADMIN_EMAIL = 'global@petroninja.com';
export const GLOBAL_ADMIN_USER_IDS = ['PntME7', 'gvtajW'];

export function isEditable(
  arg: WorkspaceItem | Project,
  user: User | undefined
): boolean {
  if (isNil(user) || arg.origin === 'stackdx') {
    return false;
  }

  if (arg.isGlobal && user.isAdmin && user.email === GLOBAL_ADMIN_EMAIL) {
    return true;
  }

  if (isNil(arg.createdBy)) {
    return false;
  }

  return arg.createdBy.id === user.id;
}

type StyleEditability =
  | 'no_editability'
  | 'full_editability'
  | 'limited_editability';

export function getStyleEditability(
  item: WorkspaceItem,
  user: User | undefined
): StyleEditability {
  if (isNil(user)) return 'no_editability';

  const isCreator = item.createdBy?.id === user.id;
  const isGlobalAdminUser =
    item.isGlobal && user.isAdmin && user.email === GLOBAL_ADMIN_EMAIL;

  if (isCreator || isGlobalAdminUser) return 'full_editability';
  if (item.isGlobal) return 'no_editability';

  return 'limited_editability';
}
